import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-permission-deny',
  templateUrl: './permission-deny.component.html',
  styleUrls: ['./permission-deny.component.scss']
})
export class PermissionDenyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
